<template>
  <div class="detail">
    <my-header :title="symbol +' Swap'"></my-header>
    <div class="infos flex">
      <div class="item left">
        <div
          class="price"
          :class="infos.priceChangePercent > 0 ? 'green' : 'red'"
        >
          {{ infos.lastPrice | toFixedTwo }}
        </div>
        <div
          class="change"
          :class="infos.priceChangePercent > 0 ? 'green' : 'red'"
        >
          {{ infos.priceChangePercent | toFixedTwo }}%
        </div>
      </div>
      <div class="item right">
        <div class="row">
          <span class="label">High(24h)</span>
          <span class="value">{{ infos.highPrice | toFixedTwo }}</span>
        </div>
        <div class="row">
          <span class="label">Low(24h)</span>
          <span class="value">{{ infos.lowPrice | toFixedTwo }}</span>
        </div>
        <div class="row">
          <span class="label">Quantity(24h)</span>
          <span class="value">{{ infos.volume | toFixedTwo }}</span>
        </div>
      </div>
    </div>
    <div ref="chartContainer" class="mychart"></div>
    <div class="g_sort_header">
      <div class="item" @click="sortBy('date')">
        Date <i :class="sortIcon('date')"></i>
      </div>
      <div class="item" @click="sortBy('buy')">
        BuyVol <i :class="sortIcon('buy')"></i>
      </div>
      <div class="item" @click="sortBy('sell')">
        SelVol <i :class="sortIcon('sell')"></i>
      </div>
    </div>
    <div class="list">
      <div class="item" v-for="item in listData" :key="item.startTime">
        <div class="date">{{ item.endTime }}</div>
        <div class="buy">{{ item.buyVol }}</div>
        <div class="sell">{{ item.sellVol }}</div>
      </div>
    </div>
    <div class="footer-button">
      <div class="btn fall" @click="clickBuyBtn('fall')">
        <svg
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M866.742857 762.148571l-20.48-170.788571a6.948571 6.948571 0 0 0-11.702857-4.022857l-50.834286 51.2-232.594285-232.594286a14.262857 14.262857 0 0 0-19.382858 0l-87.04 87.04L207.36 256a6.948571 6.948571 0 0 0-9.508571 0L159.085714 294.765714a6.948571 6.948571 0 0 0 0 9.508572l275.748572 276.114285a13.531429 13.531429 0 0 0 19.382857 0l87.405714-87.405714 193.828572 193.828572-50.834286 50.834285a6.948571 6.948571 0 0 0 4.022857 11.702857l170.422857 20.48a6.582857 6.582857 0 0 0 7.68-7.68z"
          ></path>
        </svg>
        <span>{{ infos.lastPrice | toFixedTwo }}</span>
        <span> BUY FALL</span>
      </div>
      <div class="btn up" @click="clickBuyBtn('up')">
        <svg
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M859.062857 256l-170.788571 20.48a6.948571 6.948571 0 0 0-4.022857 11.702857l50.834285 49.005714-193.462857 193.828572-87.405714-87.405714a13.897143 13.897143 0 0 0-19.382857 0l-275.748572 275.748571a7.314286 7.314286 0 0 0 0 9.874286L197.851429 768a6.948571 6.948571 0 0 0 9.508571 0l237.348571-236.982857 87.04 87.04a14.262857 14.262857 0 0 0 19.382858 0l232.594285-232.594286 50.834286 50.834286a6.948571 6.948571 0 0 0 11.702857-4.022857l20.48-170.788572a6.582857 6.582857 0 0 0-7.68-5.485714z"
          ></path>
        </svg>
        <span>{{ infos.lastPrice | toFixedTwo }}</span>
        <span> BUY UP</span>
      </div>
    </div>

    <div class="ui dimmer modals page transition" :class="{active:isShowBuyBox}">
      <div class="ui modal page active">
        <i class="close icon" @click="cancel"></i>
        <div class="header">Place an Order</div>
        <div class="ui form">
          <div class="inline field">
            <label>Quantity</label>
            <input type="text" placeholder="quantity" v-model="amount"/>
          </div>
          <div class="inline fields" style="flex-wrap:wrap;">
            <div class="field" v-for="item in multipleOptions" :key="item">
              <div class="ui radio checkbox" :class="{disabled:disabledChecked(item)}" @click="selectMultip(item)">
                <input
                  type="radio"
                  name="fruit"
                  tabindex="0"
                  class="hidden"
                  :value="item"
                  :checked="item === multiple"
                />
                <label>X{{item}}</label>
              </div>
            </div>
          </div>
        </div>
        <div class="actions">
          <div class="ui button" @click="cancel">Cancel</div>
          <div class="ui positive right labeled icon button" @click="executeBuy">
            Buy-ins
            <i class="checkmark icon"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import MyHeader from "@/components/MyHeader.vue";
import { getKline, volumnPerTimeslot, get24hr, createOrder } from "../http/api";
import moment from "moment";
import { MyStorage } from '@/js/utils';

export default {
  components: { MyHeader },
  name: "currencyDetail",
  data() {
    return {
      sortKey: "", // 当前排序的字段
      sortDirection: "", // 当前排序的方向（'asc' 或 'desc'）
      infos: [],
      symbol: "",
      listData: [],
      isShowBuyBox:false,
      buyType:"",
      multiple:1,
      multipleOptions:[1,2,3,5,10,30,50,80,100],
      amount:"",
      allowFetch:false,
      userLv:'1'
    };
  },
  filters: {
    toFixedTwo(value) {
      if (isNaN(value)) {
        return value;
      }
      return parseFloat(value).toFixed(2);
    },
  },
  created() {
    this.symbol = this.$route.query.symbol;
    this.userLv = MyStorage.getItem("userLv")
    this.getMainData()
    this.getDealList();
  },
  mounted(){
    this.allowFetch = true;
  },
  beforeRouteLeave(to, from, next) {
    this.allowFetch = false;
    next();
  },
  methods: {
    calculateMA(dayCount, data) {
      let result = [];
      for (let i = 0, len = data.length; i < len; i++) {
        if (i < dayCount) {
          result.push("-");
          continue;
        }
        let sum = 0;
        for (let j = 0; j < dayCount; j++) {
          sum += +data[i - j][1];
        }
        result.push((sum / dayCount).toFixed(2));
      }
      return result;
    },
    disabledChecked(item){
      if(this.userLv == '1' && item>1){
        return true;
      }else if(this.userLv == '2' && item>10){
        return true;
      }else if(this.userLv == '3'){
        return false;
      }
    },
    selectMultip(item){
      if(this.userLv == '1' && item<2){
        this.multiple = item;
      }else if(this.userLv == '2' && item<=10){
        this.multiple = item;
      }else if(this.userLv == '3'){
        this.multiple = item;
      }
    },
    sortBy(key) {
      if(!this.listData) return;
      if (this.sortKey === key) {
        this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
      } else {
        this.sortKey = key;
        this.sortDirection = "asc";
      }
      // 在这里根据 sortKey 和 sortDirection 进行实际的列表排序操作
      const sortOrder = (this.sortDirection === 'desc') ? -1 : 1;
      let sortName = "";
      if(key==="date"){
        sortName = "endTime"
      }else if(key==="buy"){
        sortName = "buyVol"
      }else if(key==="sell"){
        sortName = "sellVol"
      }
      this.listData.sort((a,b)=>{
        let x = a[sortName];
        let y = b[sortName];
        if(sortName === "buyVol" || sortName === "sellVol"){
          x = parseFloat(x)
          y = parseFloat(y)
        }
        if (x > y) {
          return sortOrder;
        } else if (x < y) {
          return -sortOrder;
        } else {
          return 0;
        }
      })
    },
    sortIcon(key) {
      if (this.sortKey === key) {
        return this.sortDirection === "asc"
          ? "sort amount up icon"
          : "sort amount down icon";
      }
      return "sort icon";
    },
    async getMainData() {
      this.$loading.show();
      try {
        await this.getMainInfo();
        await this.getDetail();
        this.$loading.hide();
        setTimeout(() => {
          if (this.allowFetch) {
            this.getMainData();
          }
        }, 5000);
      } catch (error) {
        this.$loading.hide();
        this.$toast.show(error.message)
      }
    },
    async getMainInfo() {
      const res = await get24hr({ symbol: this.symbol });
      if(res && res.data){
        this.infos = res.data[0];
      }
    },
    async getDealList() {
      const data = {
        symbol: this.symbol,
      };
      const res = await volumnPerTimeslot(data)
      if(res && res.data){
        this.listData = res.data;
        //5分钟后调用一次
        setTimeout(() => {
          if (this.allowFetch) {
            this.getMainData();
          }
        }, 1000*60*5);
      }
    },
    async getDetail() {
      const data = {
        symbol: this.symbol,
        interval: "5m",
        endTime: moment().format("YYYY-MM-DD HH:mm:00"),
        startTime: moment().subtract(24, "hours").format("YYYY-MM-DD HH:mm:00"),
      };
      this.$loading.show()
      const res = await getKline(data);
      if(res && res.data){
        this.$loading.hide()
        this.drawKline(res.data);
      }
    },
    drawKline(listData) {
      // 获取DOM元素
      const chartContainer = this.$refs.chartContainer;
      // 创建echarts实例
      const myChart = echarts.init(chartContainer);
      const colorList = [
        "#c23531",
        "#2f4554",
        "#61a0a8",
        "#d48265",
        "#91c7ae",
        "#749f83",
        "#ca8622",
        "#bda29a",
        "#6e7074",
        "#546570",
        "#c4ccd3",
      ];
      const labelFont = "bold 12px Sans-serif";
      const dates = listData.map((item) => {
        const formattedDateTime = moment(item.openTime).format("DD/HH:mm");
        return formattedDateTime;
      });
      const data = listData.map((item) => {
        return [
          item.openPrice,
          item.lastPrice,
          item.lowPrice,
          item.highPrice,
          item.volume,
        ];
      });
      const dataMA5 = this.calculateMA(5, data);
      const dataMA10 = this.calculateMA(10, data);
      const dataMA20 = this.calculateMA(20, data);
      const option = {
        animation: false,
        color: colorList,
        title: {
          left: "center",
          text: "",
        },
        legend: {
          top: 30,
          data: ["日K", "MA5", "MA10", "MA20", "MA30"],
        },
        tooltip: {
          triggerOn: "none",
          transitionDuration: 0,
          confine: true,
          borderRadius: 4,
          borderWidth: 1,
          borderColor: "#333",
          backgroundColor: "rgba(255,255,255,0.9)",
          textStyle: {
            fontSize: 12,
            color: "#333",
          },
          position: function (pos, params, el, elRect, size) {
            const obj = {
              top: 30,
            };
            obj[["left", "right"][+(pos[0] < size.viewSize[0] / 2)]] = 5;
            return obj;
          },
        },
        axisPointer: {
          link: [
            {
              xAxisIndex: [0, 1],
            },
          ],
        },
        dataZoom: [
          {
            type: "slider",
            xAxisIndex: [0, 1],
            realtime: false,
            start: 20,
            end: 70,
            top: 65,
            height: 20,
            handleIcon:
              "path://M10.7,11.9H9.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z",
            handleSize: "120%",
          },
          {
            type: "inside",
            xAxisIndex: [0, 1],
            start: 40,
            end: 70,
            top: 30,
            height: 20,
          },
        ],
        xAxis: [
          {
            type: "category",
            data: dates,
            boundaryGap: false,
            axisLine: { lineStyle: { color: "#777" } },
            min: "dataMin",
            max: "dataMax",
            axisPointer: {
              show: true,
            },
          },
          {
            type: "category",
            gridIndex: 1,
            data: dates,
            boundaryGap: false,
            splitLine: { show: false },
            axisLabel: { show: false },
            axisTick: { show: false },
            axisLine: { lineStyle: { color: "#777" } },
            min: "dataMin",
            max: "dataMax",
            axisPointer: {
              type: "shadow",
              label: { show: false },
              triggerTooltip: true,
              handle: {
                show: true,
                margin: 30,
                color: "#B80C00",
              },
            },
          },
        ],
        yAxis: [
          {
            scale: true,
            splitNumber: 2,
            axisLine: { lineStyle: { color: "#777" } },
            splitLine: { show: true },
            axisTick: { show: false },
            axisLabel: {
              inside: true,
              formatter: "{value}\n",
            },
          },
          {
            scale: true,
            gridIndex: 1,
            splitNumber: 2,
            axisLabel: { show: false },
            axisLine: { show: false },
            axisTick: { show: false },
            splitLine: { show: false },
          },
        ],
        grid: [
          {
            left: 20,
            right: 20,
            top: 110,
            height: 120,
          },
          {
            left: 20,
            right: 20,
            height: 40,
            top: 260,
          },
        ],
        graphic: [
          {
            type: "group",
            left: "center",
            top: 70,
            width: 300,
            bounding: "raw",
            children: [
              {
                id: "MA5",
                type: "text",
                style: { fill: colorList[1], font: labelFont },
                left: 0,
              },
              {
                id: "MA10",
                type: "text",
                style: { fill: colorList[2], font: labelFont },
                left: "center",
              },
              {
                id: "MA20",
                type: "text",
                style: { fill: colorList[3], font: labelFont },
                right: 0,
              },
            ],
          },
        ],
        series: [
          {
            type: "candlestick",
            name: "日K",
            data: data,
            itemStyle: {
              color: "#ef232a",
              color0: "#14b143",
              borderColor: "#ef232a",
              borderColor0: "#14b143",
            },
            emphasis: {
              itemStyle: {
                color: "black",
                color0: "#444",
                borderColor: "black",
                borderColor0: "#444",
              },
            },
          },
          {
            name: "MA5",
            type: "line",
            data: dataMA5,
            smooth: true,
            showSymbol: false,
            lineStyle: {
              width: 1,
            },
          },
          {
            name: "MA10",
            type: "line",
            data: dataMA10,
            smooth: true,
            showSymbol: false,
            lineStyle: {
              width: 1,
            },
          },
          {
            name: "MA20",
            type: "line",
            data: dataMA20,
            smooth: true,
            showSymbol: false,
            lineStyle: {
              width: 1,
            },
          },
        ],
      };
      myChart.setOption(option);
    },
    clickBuyBtn(type){
      this.isShowBuyBox = true;
      this.buyType = type;
    },
    cancel(){
      this.isShowBuyBox = false;
      this.buyType = "";
      this.multiple = 1;
      this.amount = "";

    },
    async executeBuy(){
      const data = {
        currency:this.symbol,
        amount:this.amount,
        multiple:this.multiple,
        orderContent:this.buyType=="fall"?1:2
      }
      this.$loading.show()
      const res = await createOrder(data)
      if(res && res.message){
        this.$loading.hide()
        this.$toast.show(res.message)
        this.cancel();
      }
    }
  },
};
</script>

<style lang="less" scoped>
.detail {
  position: relative;
  width: 100%;
  height: 100%;
  .infos {
    background-color: #fff;
    padding: 10px 20px;
    .item {
      flex-grow: 1;
      &.left {
        min-width: 50%;
        padding-top: 10px;
      }
      &.right {
        .row {
          font-size: 12px;
          line-height: 20px;
          .label {
            color: #ccc;
            margin-right: 5px;
          }
        }
      }
    }
    .price {
      font-size: 30px;
      &.red {
        color: red;
      }
      &.green {
        color: green;
      }
    }
    .change {
      font-size: 18px;
      margin-top: 6px;
      &.red {
        color: red;
      }
      &.green {
        color: green;
      }
    }
  }
  .mychart {
    width: 100%;
    height: 300px;
    position: relative;
    z-index: 1;
    background-color: #fff;
  }
  .g_sort_header {
    margin-top: -30px;
    position: relative;
    z-index: 3;
    .item {
      text-align: center;
    }
  }
  .list {
    background-color: #fff;
    height: calc(100vh - 500px);
    overflow-y: scroll;
    .item {
      display: flex;
      padding: 10px;
      border-bottom: 1px solid #ddd;
      .date,
      .buy,
      .sell {
        flex-grow: 1;
      }
      .buy {
        color: red;
      }
      .sell {
        color: green;
      }
    }
  }
  .footer-button {
    position: absolute;
    bottom: 0;
    height: 50px;
    line-height: 50px;
    width: 100%;
    overflow: hidden;
    .btn {
      display: inline-block;
      width: 50%;
      overflow: hidden;
      text-align: center;
      color: #fff;
      cursor: pointer;
      &.fall {
        background-color: #f00;
      }
      &.up {
        background-color: green;
      }
      svg {
        width: 30px;
        vertical-align: middle;
        path {
          fill: #fff;
        }
      }
      span {
        vertical-align: middle;
      }
    }
  }
  .form {
    padding: 16px;
  }
  .ui.modal{
    width: 80%;
    max-width: 400px;
  }
  .ui.form .inline.fields .field{
    margin-bottom: 8px;
  }
}
</style>